<template>
  <div class="background">
    <hotjar site-id="2286397"></hotjar>
    <navbar></navbar>
    <div class="verification-container">
      <router-view />
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

import {
  APPLICANT_VERIFICATION_SUCCESS,
  APPLICANT_VERIFICATION_REQUEST
} from "@/store/types";

const baseUrl = process.env.VUE_APP_BACKEND_HOST;

export default {
  computed: {
    ...mapGetters(["getApplicantVerification", "isApplicantLoading"])
  },
  async mounted() {
    const { token, verifyType, emailVerifyToken } = this.$route.params;

    try {
      axios.defaults.headers.common["Authorization"] =
        token || emailVerifyToken;
      this.$store.commit(APPLICANT_VERIFICATION_REQUEST);

      const response = await axios.get(
        `${baseUrl}/api/verify/v1/verifications/`
      );

      this.$store.commit(APPLICANT_VERIFICATION_SUCCESS, {
        verifyType,
        verification: response.data
      });

      const currentStage = response.data.current_stage;

      if (currentStage) {
        this.$router.push({
          name: `verify-applicant-${currentStage}`,
          params: { verifyType }
        });
      } else {
        this.$router.push({
          name: "verify-applicant-start",
          params: { verifyType }
        });
      }
    } catch (err) {
      console.log(err.response);
      if (err.response.data.message === "Link expired") {
        this.$router.push({ name: "expired" });
      } else {
        this.$router.push({ name: "not-found" });
      }
    }
  },
  data() {
    return {
      gtmLoaded: false
    };
  }
};
</script>
<style lang="scss" scoped>
.background {
  background-color: white;
  height: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .verification-container {
    height: 100vh;
  }
}
@media (max-width: 768px) {
  .verification-container {
    width: 100%;

    .verification-view {
      padding: 5px 5px;
    }
  }
}
</style>
